import { render, staticRenderFns } from "./ActOfAcceptanceTab.vue?vue&type=template&id=277da68f&"
import script from "./ActOfAcceptanceTab.vue?vue&type=script&lang=js&"
export * from "./ActOfAcceptanceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports